<template>
  <v-container fluid class="item-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Item</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                      <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">New Item</p>
                        <v-text-field
                          class="mb-4"
                          v-model="item.itemnum"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Item Num"
                          persistent-hint
                          single-line hint="Enter the item num">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="item.itemname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Item Name"
                          persistent-hint
                          single-line hint="Enter the item name">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="item.itemsalesdesc"
                          outlined
                          dense
                          placeholder="Sales Description"
                          persistent-hint
                          single-line hint="Enter the item sales description">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items="['Item', 'Gift Item', 'Other Item']"
                          v-model="item.itemtype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the item type">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="brands.map(x => {
                            return {text: x.brandname, value: x._id};
                          })"
                          v-model="item.brandid"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Brand"
                          persistent-hint
                          single-line hint="Please choose the item brand">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="itemgroups.map(x => {
                            return {text: x.itemgroupname, value: x._id};
                            })"
                          v-model="item.itemgroupid"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Group"
                          persistent-hint
                          single-line hint="Please choose the item group">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="itemcategories.map(x => {
                            return {text: x.itemcategoryname, value: x._id};
                            })"
                          v-model="item.itemcategoryid"
                          v-bind:error="errorindex == 5"
                          outlined
                          dense
                          placeholder="Category"
                          persistent-hint
                          single-line hint="Please choose the item category">
                        </v-select>
                          <v-switch
                            v-model="item.itemstatus"
                            color="primary"
                            v-bind:label="item.itemstatus"
                            value="Active"
                          ></v-switch>
                        <div class="d-flex justify-end">

                        </div>


                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6" sm="5">
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/item/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onChangeImage" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertItem()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      item: {},
      error: undefined,
      errorindex: undefined,
      haserror: false,
    }
  },

  methods: {
    ...mapActions('Item', ['insertItemRequest', 'insertItemWithImageRequest', 'getItemsRequest']),
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('ItemCategory', ['getItemCategoriesRequest']),
    ...mapActions('ItemGroup', ['getItemGroupsRequest']),
    checkError(){
      if(!this.item.itemnum){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.item.itemname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.item.itemtype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.item.brandid){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.item.itemgroupid){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
        if(!this.item.itemcategoryid){
        this.haserrors = true;
        this.errorindex = 5;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertItem() {
      if(this.item.itemimage) this.insertItemWithImageRequest(this.item);
      else this.insertItemRequest(this.item);
      
      await this.getItemsRequest()
      router.push('/item/list')
    },
    onChangeImage(file) {
      if (!file) {return;}
      this.item.itemimage = file;
      this.item.imagename = file.name;
      const reader = new FileReader();
      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  },
  computed: {
    ...mapState('Item', ['isReceiving']),
    ...mapState('Brand', ['brands']),
    ...mapState('ItemCategory', ['itemcategories']),
    ...mapState('ItemGroup', ['itemgroups']),
  },
  async created () {
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.itemcategories.length==0) await this.getItemCategoriesRequest();
    if(this.itemgroups.length==0) await this.getItemGroupsRequest();
  },
}
</script>

<style src="./Add.scss" lang="scss"></style>
